import { render, staticRenderFns } from "./groupParcel.vue?vue&type=template&id=a510dbb8&scoped=true&"
import script from "./groupParcel.vue?vue&type=script&lang=js&"
export * from "./groupParcel.vue?vue&type=script&lang=js&"
import style0 from "./groupParcel.vue?vue&type=style&index=0&id=a510dbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510dbb8",
  null
  
)

export default component.exports